import * as cpUseList from '../services/cpUseList';

export default {
  namespace: 'cpUseList',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
    allTotal: 0,
  },

  effects: {
    *getCpUseList({ payload: { values } }, { call, put }) {
      const response = yield call(cpUseList.getCpUseList, values);
      yield put({
        type: 'save',
        payload: {
          cpUseList: response?.data,
        },
      });
    },
    *getCpUseListNum({ payload: { values } }, { call, put }) {
      const response = yield call(cpUseList.getCpUseList, values);
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },
    // *addMember({ payload: { values }, callback }, { call, put }) {
    //   const response = yield call(cpList.addMember, values);
    //   if (response) {
    //     if (callback && typeof callback === 'function') {
    //       return callback(response);
    //     }
    //   }
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       addMember: response,
    //     },
    //   });
    // },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
